import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import products from "../data/products";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const onProductsActive = location.pathname.startsWith("/products");

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand">
          <span className="brand-mark">BF</span>
          <span className="brand-name">Byteflow</span>
        </Link>

        <nav className={`site-header__nav ${menuOpen ? "is-open" : ""}`}>
          <NavLink to="/" end className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}>
            Home
          </NavLink>

          <div
            className={`nav-dropdown ${dropdownOpen ? "is-open" : ""}`}
            ref={dropdownRef}
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button
              type="button"
              className={"nav-link nav-dropdown__trigger" + (onProductsActive ? " is-active" : "")}
              aria-haspopup="true"
              aria-expanded={dropdownOpen}
              onClick={() => setDropdownOpen((v) => !v)}
            >
              Products <span className="nav-dropdown__chevron" aria-hidden>▾</span>
            </button>
            <div className="nav-dropdown__menu" role="menu">
              <Link to="/products" className="nav-dropdown__overview" role="menuitem">
                <strong>All products</strong>
                <span>Compare the full Byteflow suite</span>
              </Link>
              <div className="nav-dropdown__list">
                {products.map((p) => (
                  <Link
                    to={`/products/${p.slug}`}
                    key={p.slug}
                    className="nav-dropdown__item"
                    role="menuitem"
                  >
                    <span className="nav-dropdown__icon" aria-hidden>{p.icon}</span>
                    <span className="nav-dropdown__body">
                      <strong>
                        {p.name}
                        {p.flagship && <span className="nav-dropdown__badge">Flagship</span>}
                      </strong>
                      <span>{p.tagline}</span>
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <NavLink to="/about" className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}>About</NavLink>
          <NavLink to="/pricing" className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}>Pricing</NavLink>
          <NavLink to="/projects" className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}>Projects</NavLink>
          <NavLink to="/clients" className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}>Clients</NavLink>
          <NavLink to="/testimonials" className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}>Testimonials</NavLink>

          <Link to="/contact" className="nav-cta">Request Demo</Link>
        </nav>

        <button
          type="button"
          className={`hamburger ${menuOpen ? "is-open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Header;
